import {
    Validate
} from '../global/_formValidation';
import {
    getURLParamValue
} from '../global/_getURLParamValue';

const populateCYL = () => {
    var _json = $('#this-look-carousel').data('thisLook'),
        _html = '',
        _currentImage = (!$('.desktopPage').length > 0) ? $('.mainProductImage .slick-active img').attr('src') : $('.mainImage').attr('src');
    if (_json.accessories.length > 0 && _currentImage.split('missing-full-img.jpg').length < 2) {
        var mainImageSplit = _currentImage.split('/'),
            mainImageName = mainImageSplit[mainImageSplit.length - 1];
        $.each(_json.accessories, function (imageNumber, value) {
            if (mainImageName == value.dil_oss_product_image_name + '.jpg') {
                $.each(value.dil_oss_accessories, function (index, accessory) {
                    if (accessory.dil_oss_acc_name && accessory.dil_oss_acc_name.length > 0 && accessory.dil_oss_acc_fullImage && accessory.dil_oss_acc_fullImage.length > 0) {
                        let _accessoryName = accessory.dil_oss_acc_name,
                            _accessNameForTracking = _accessoryName.replace(/\s+/g, '-').split('&').join('').toLowerCase(),
                            catentryId = accessory.dil_oss_acc_catentry_id,
                            _mainProductName = _json.mainProduct.name ? _json.mainProduct.name.replace(/\s+/g, '-').toLowerCase() : `noProductName_${catentryId}`,
                            _accessoryTitleWithHyphens = _accessoryName.replace(/\s+/g, '-').split('"').join('').split('&').join('').split('?').join('').split('/').join('').split('#double;').join('').split('#').join('').toLowerCase(),
                            _cm_real_estate_tag = `thisLook-_-${Validate.stripProhibitedCharacters(_mainProductName)}-_-${Validate.stripProhibitedCharacters(_accessNameForTracking)}`;
                        _html += `<div class="item"><a data-twist="product-img-link-${index}" class="quick-view-trigger" href="/p/${_accessNameForTracking}/${catentryId}"
																	data-modal-title="${_accessoryName}" data-toggle="modal" data-target=".modal-quickview" data-modal-body=\'callQuickView({"catentryId": "${catentryId}","categoryId": "","OSS":"true"})\'>
																	<img data-pagetype="PP-QV-OSS" data-catentryid="${catentryId}"`;
                        if (accessory.dil_oss_vendor_color && accessory.dil_oss_vendor_color.length > 0)
                            _html += ` data-color="${accessory.dil_oss_vendor_color}" `;
                        _html += `data-twist="product-image-${index}" class="product-image" alt="${_accessoryName} Image" src="//dimg.dillards.com/is/image/DillardsZoom/nav/${_accessoryTitleWithHyphens}/${accessory.dil_oss_acc_fullImage}.jpg">
												          <span data-twist="quick-view-${index}" class="btn quickview-btn">Quick View<span class="sr-only">Opens a simulated dialog</span></span></a></div>`;
                    }
                });
            }
        });
        if (_html.length > 0) {
            $('#this-look-carousel').append(_html);
            $('#this-look-wrapper').show();
        } else $('#this-look-wrapper').hide();
        setTimeout(function () {
            if ($('#this-look-carousel .item').length > 0) {
                $('.quickview-btn').addClass('prevent-double-click-hack-for-ibm-cookie-problem');
                $('#this-look-carousel').not('.slick-intialized').slick({
                    infinite: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    prevArrow: '<i class="fa fa-angle-left slickCustomPrev" aria-hidden="true"></i>',
                    nextArrow: '<i class="fa fa-angle-right slickCustomNext" aria-hidden="true"></i>',
                    responsive: [{
                        breakpoint: 1025,
                        settings: {
                            arrows: false,
                            swipe: true,
                            swipeToSlide: true
                        }
                    }]
                });
                if ($('#this-look-wrapper').length > 0) $('#this-look-wrapper .divider').css({
                    'display': 'block'
                });
                $('#this-look-carousel').show();
            }
        }, 0);
    }
};

const updateCYL = () => {
    var cylCarousel = $('#this-look-carousel');
    if (cylCarousel.hasClass('slick-initialized')) {
        cylCarousel.slick('unslick');
        cylCarousel.empty();
    }
    populateCYL();
}

const needToUpdate = (imgSelector) => {
    var _json = $('#this-look-carousel').data('thisLook'),
        _currentImage = $(imgSelector).attr('src'),
        currentLook = [];
    $.each($('#this-look-carousel img'), function () {
        currentLook.push($(this).data('catentryid'));
    });
    if (_json.accessories.length > 0 && _currentImage.split('missing-full-img.jpg').length < 2) {
        var mainImageSplit = _currentImage.split('/'),
            mainImageName = mainImageSplit[mainImageSplit.length - 1],
            potentialLook = [];
        $.each(_json.accessories, function (imageNumber, value) {
            if (mainImageName == `${value.dil_oss_product_image_name}.jpg`) {
                $.each(value.dil_oss_accessories, function (index, accessory) {
                    let productName = accessory.dil_oss_acc_name,
                        imgName = accessory.dil_oss_acc_fullImage,
                        productNameExists = productName && productName.length > 0,
                        imgNameExists = imgName && imgName.length > 0;
                    if (productNameExists && imgNameExists) potentialLook.push(accessory.dil_oss_acc_catentry_id);
                });
            }
        });
    }
    return (currentLook.toString() == potentialLook.toString()) ? false : true;
}

export const getCYL = () => {
    if ($('#this-look-carousel').length > 0) {
        var dataString = `storeId=301&catalogId=301&langId=-1&catentryId=${$('form#OrderItemAdd_0 input[name="catEntryId"]').val()}`,
            forceDatabase = getURLParamValue("forceDatabase");
        if (forceDatabase != '') dataString += `&forceDatabase=${forceDatabase}`;

        $.ajax({
            url: "/webapp/wcs/stores/servlet/OurStylistSuggestView",
            cache: true,
            type: "GET",
            dataType: "json",
            data: dataString,
            success: function (json) {
                $('#this-look-carousel').data('thisLook', json);
                populateCYL();
                if ($('.desktopPage').length > 0) {
                    $('.mainProductImage img').on('load', _.debounce(function () {
                        if (needToUpdate('.mainImage')) updateCYL();
                    }));
                } else {
                    $('#layoutProduct .slickWrapper').on('setPosition', _.debounce(function (event, slick, direction) {
                        if (needToUpdate('.mainProductImage .slick-active img')) updateCYL();
                    }));
                }
            },
            error: function (jqXHR, exception) {
                var msg = '';
                switch (jqXHR.status) {
                    case 0:
                        msg = 'Not connect.\n Verify Network.';
                        break;
                    case 404:
                        msg = 'Requested page not found. [404]';
                        break;
                    case 500:
                        msg = 'Internal Server Error [500].';
                        break;
                    default:
                        switch (exception) {
                            case 'parsererror':
                                msg = 'Requested JSON parse failed.';
                                break;
                            case 'timeout':
                                msg = 'Time out error.';
                                break;
                            case 'abort':
                                msg = 'Ajax request aborted.';
                                break;
                            default:
                                msg = `Uncaught Error.\n${jqXHR.responseText}`;
                                break;
                        }
                        break;
                }
                return msg;
            }
        });
    }
};
